<template>
  <label class="hs-checkbox" :class="{ 'is-disabled': disabled }">
    <span class="hs-checkbox__box" :class="{ 'is-checked': modelValue }">
      <input
        type="checkbox"
        :checked="modelValue"
        :disabled="disabled"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
      <hs-icon v-if="modelValue" name="check" :size="14" />
    </span>
    <span class="hs-checkbox__content">
      <strong v-if="label">{{ label }}</strong>
      <small v-if="description">{{ description }}</small>
    </span>
  </label>
</template>

<script>
import HsIcon from "./HsIcon.vue";

export default {
  name: "HsCheckbox",
  components: { HsIcon },
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: "" },
    description: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.hs-checkbox {
  align-items: flex-start;
  cursor: pointer;
  display: inline-flex;
  gap: 0.7rem;
}

.hs-checkbox__box {
  align-items: center;
  background: color-mix(in srgb, var(--hs-bg, #f9fafb) 72%, var(--hs-surface, #fff));
  border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  border-radius: 10px;
  color: #fff;
  display: inline-flex;
  height: 1.35rem;
  justify-content: center;
  margin-top: 0.1rem;
  position: relative;
  width: 1.35rem;
}

.hs-checkbox__box.is-checked {
  background: linear-gradient(135deg, var(--hs-primary, #3293ec), var(--hs-primary-strong, #1d4ed8));
  border-color: transparent;
}

.hs-checkbox input {
  inset: 0;
  opacity: 0;
  position: absolute;
}

.hs-checkbox__content {
  display: grid;
  gap: 0.2rem;
}

.hs-checkbox strong {
  color: var(--hs-text, #0f172a);
  font-size: 0.86rem;
  font-weight: 950;
}

.hs-checkbox small {
  color: var(--hs-muted, #64748b);
  font-size: 0.76rem;
  font-weight: 700;
}

.is-disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
</style>
